/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoAddComponent
 * Purpose		: This component allows to create new CustomerCustomerDemo record and save changes.
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerCustomerDemoData, CustomerCustomerDemoService } from './CustomerCustomerDemo.service';
import { CustomersData, CustomersService } from '../Customers/Customers.service';


@Component({
	selector: 'my-CustomerCustomerDemo-add',
	template: require('./CustomerCustomerDemoAdd.component.html'),
	providers: [CustomerCustomerDemoService
		, CustomersService
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerCustomerDemoAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objCustomerCustomerDemo: CustomerCustomerDemoData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	CustomersList: CustomersData[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private CustomerCustomerDemoService: CustomerCustomerDemoService
			, private  CustomersService:  CustomersService

	) {
		this.objCustomerCustomerDemo = new CustomerCustomerDemoData();
	}

	ngOnInit() {
		this.objCustomerCustomerDemo = new CustomerCustomerDemoData();
		this.getLookups();
	}

	addCustomerCustomerDemo() {
		this.CustomerCustomerDemoService.addCustomerCustomerDemoData(this.objCustomerCustomerDemo)
			.subscribe(record => this.router.navigate(['/CustomerCustomerDemo']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('CustomerCustomerDemo record added successfully...', 'Add CustomerCustomerDemo');
				console.log('CustomerCustomerDemo record added successfully...'); 
			}
		);
	}

	gotoCustomerCustomerDemo() {
		// let Id = this.objCustomerCustomerDemo ? this.objCustomerCustomerDemo.CustomerID : null;
		this.router.navigate(['/CustomerCustomerDemo']);
	}

	// Get Lookup List for Customers
    getCustomers() {
		this.CustomersService.getAll().subscribe(records => this.CustomersList=records);
    }

	getLookups() {

        this.getCustomers();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemoAdd.component.ts